import script from "./itemV3ImageGridWeddingRings.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3ImageGridWeddingRings.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3ImageGridWeddingRings.vue?vue&type=style&index=0&id=717a9f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717a9f04"]])

export default __exports__